<script lang="ts" setup>
import type { AppSvgIconType } from '../appSvgIcon/AppSvgIcon.model';
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';

import type { AppTabsSize, AppTabsType } from './AppTabs.model';

interface AppTabProps {
  title: string;
  isOpen: boolean;
  type: AppTabsType;
  size: AppTabsSize;
  icon?: AppSvgIconType;
}

const props = defineProps<AppTabProps>();
</script>

<template>
  <div
    class="app-tab"
    :class="{ open: props.isOpen, [props.type]: true, [props.size]: true }"
  >
    <div class="app-tab-title">
      <div v-if="props.icon" class="app-tab-icon">
        <AppSvgIcon :name="props.icon" size="18" />
      </div>
      <div class="app-tab-title-text">
        {{ props.title }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '../../styles/fonts' as *;

.app-tab {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  cursor: pointer;
  transition: color var(--transition-short);

  &.wide {
    &.medium {
      padding: var(--spacing-12) var(--spacing-16);

      .app-tab-title .app-tab-title-text {
        @include font-label-m-bold;
      }
    }

    &.open {
      .app-tab-title {
        color: var(--color-neutral-70);
      }
    }
  }

  &.compact {
    &.small {
      padding: var(--spacing-8) var(--spacing-16);

      .app-tab-title .app-tab-title-text {
        @include font-label-s-light;
      }

      &.open {
        .app-tab-title .app-tab-title-text {
          @include font-label-s-bold;
        }
      }
    }
    &.medium {
      padding: var(--spacing-12) var(--spacing-24);

      .app-tab-title .app-tab-title-text {
        @include font-label-m-light;
      }

      &.open {
        .app-tab-title .app-tab-title-text {
          @include font-label-m-bold;
        }
      }
    }
  }

  .app-tab-title {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: var(--spacing-8);
    color: var(--color-neutral-70);

    .app-tab-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--border-radius-12);
    }
  }
}
</style>
